// extracted by mini-css-extract-plugin
module.exports = {"progressColor":"#16556d","primaryColor":"#005670","green":"#5bc1a4","whyUsTitle":"#2e2e2e","whyUsItemTitle":"#005670","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453"};